import { render, staticRenderFns } from "./21.vue?vue&type=template&id=42fbd7e8&scoped=true&"
var script = {}
import style0 from "./21.vue?vue&type=style&index=0&id=42fbd7e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fbd7e8",
  null
  
)

export default component.exports